import React from 'react';
import { simTokens } from './tokens';

type SimCardProps = {
  children: React.ReactNode;
  className?: string;
};

const SimCard: React.FC<SimCardProps> = ({ children, className = '' }) => {
  return <section className={`${simTokens.card} ${className}`}>{children}</section>;
};

export default SimCard;
